import { AfterViewInit, Component } from '@angular/core';
import { ThemeService as ChartThemeService } from 'ng2-charts';
import { LexbeThemeService as LexbeThemeService } from '@services/lexbe-theme.service';
import { BehaviorSubject } from 'rxjs';
import { ChartOptions, LegendItem } from 'chart.js';
import { BaseComponent } from 'src/app/components/base.component';

@Component({
    template: ``,
    standalone: false
})
export abstract class CaseAnalyticsItemBaseComponent extends BaseComponent implements AfterViewInit {

  public chartLoading: boolean = true;
  public noDataInCase$ = new BehaviorSubject<boolean>(false);
  public shouldShowLoader$ = new BehaviorSubject<boolean>(true);
  public highlightedLegendItem: LegendItem = null;
  public chartFontColorOptions = {
    normal: {
      lightTheme: 'rgb(102 102 102)',
      darkTheme: 'rgb(215 215 215)'
    },
    hover: {
      lightTheme: 'rgb(0 0 0)',
      darkTheme: 'rgb(255 255 255)'
    }
  };
  public chartFontCurrentColors = {normal: this.chartFontColorOptions.normal.lightTheme, hover: this.chartFontColorOptions.hover.lightTheme};
  public chartData = {
    datasets: []
  };

  constructor(protected lexbeThemeService: LexbeThemeService,
    protected chartThemeService: ChartThemeService) {
      super();
      this.setChartThemeSettings(this.lexbeThemeService.isDarkMode());
  }

  public ngAfterViewInit() {
    this.lexbeThemeService.isDarkMode$.subscribe((value) => {
      this.setChartThemeSettings(value);
    });
  }

  private setChartThemeSettings(isDarkTheme: boolean) {
    this.setChartFontColorSettings(isDarkTheme);

    let overrides: ChartOptions;
    if (isDarkTheme) {
      overrides = {
        plugins: {
          legend: {
            labels: { color: this.chartFontCurrentColors.normal }
          },
        },
        scales: {
          x:  {
            ticks: { color: this.chartFontCurrentColors.normal },
            grid: { color: 'rgba(255,255,255,0.1)' }
          } ,
          y: {
            ticks: { color: this.chartFontCurrentColors.normal },
            grid: { color: 'rgba(255,255,255,0.1)' }
          }
        }
      };
    } else {
      overrides = {
        plugins: {
          legend: {
            labels: { color: this.chartFontCurrentColors.normal }
          },
        },
        scales: {
          x:  {
            ticks: { color: this.chartFontCurrentColors.normal },
            grid: { color: 'rgba(0,0,0,0.1)' }
          } ,
          y: {
            ticks: { color: this.chartFontCurrentColors.normal },
            grid: { color: 'rgba(0,0,0,0.1)' }
          }
        }
      };
    }
    this.chartThemeService.setColorschemesOptions(overrides);
  }

  private setChartFontColorSettings(isDarkTheme: boolean) {
    if (isDarkTheme) {
      this.chartFontCurrentColors.normal = this.chartFontColorOptions.normal.darkTheme;
      this.chartFontCurrentColors.hover = this.chartFontColorOptions.hover.darkTheme;
    }
    else {
      this.chartFontCurrentColors.normal = this.chartFontColorOptions.normal.lightTheme;
      this.chartFontCurrentColors.hover = this.chartFontColorOptions.hover.lightTheme;
    }
  }
}
